import { CircleAlertIcon, InfoIcon } from 'lucide-react';

import { WarningType } from 'types/enums/WarningType';
import {
  getWarningBannerClassName,
  getWarningTextClassName,
} from 'utils/carrierVerificationHelpers';

import { Flex } from '../layout';
import { Typography } from '../typography';

interface CarrierVerificationEmailSearchResultMessageProps {
  message: string;
  type: WarningType;
}

function WarningMessageIcon({ type }: { type: WarningType }) {
  if (type === WarningType.Error || type === WarningType.Warning) {
    return (
      <CircleAlertIcon
        className={`h-4 w-4 shrink-0 ${getWarningTextClassName(type)}`}
      />
    );
  }
  if (type === WarningType.Info) {
    return <InfoIcon className='h-4 w-4 text-info-600 shrink-0' />;
  }
  return null;
}

export default function CarrierVerificationEmailSearchResultMessage({
  message,
  type,
}: CarrierVerificationEmailSearchResultMessageProps) {
  return (
    <Flex
      align='center'
      gap='sm'
      className={`rounded-lg border p-3 w-full mb-2 ${getWarningBannerClassName(type)}`}
    >
      <WarningMessageIcon type={type} />
      <Typography variant='body-sm' className={getWarningTextClassName(type)}>
        {message}
      </Typography>
    </Flex>
  );
}
